import React from "react";
import { DollarSign, Users, TrendingDown, Activity } from "../../utils/icons";
import Card, { StatCard } from "../../components/ui/Card";
import RevenueAreaChart from "../../components/charts/AreaChart";
import UsersBarChart from "../../components/charts/BarChart";
import DonutChart from "../../components/charts/DonutChart";
import { revenueData, trafficData, statsCards } from "../../utils/dummyData";

const iconMap = { DollarSign, Users, TrendingDown, Activity };
const colorMap = {
  DollarSign: "primary",
  Users: "accent",
  TrendingDown: "red",
  Activity: "green",
};

const Analytics = () => (
  <div>
    <div className="mb-8">
      <h1 className="font-display text-2xl font-bold text-gray-900 dark:text-white">
        Analytics
      </h1>
      <p className="text-gray-500 dark:text-gray-400 mt-1">
        Real-time performance overview — last 12 months
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
      {statsCards.map((stat, i) => {
        const IconComp = iconMap[stat.icon];
        return (
          <StatCard
            key={i}
            label={stat.label}
            value={stat.value}
            change={stat.change}
            up={stat.up}
            icon={IconComp}
            color={colorMap[stat.icon]}
          />
        );
      })}
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
      <Card className="lg:col-span-2 p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="font-display font-bold text-gray-900 dark:text-white">
              Revenue Over Time
            </h3>
            <p className="text-sm text-gray-400 mt-0.5">
              Monthly recurring revenue (USD)
            </p>
          </div>
          <select className="text-sm bg-gray-100 dark:bg-gray-800 border-0 rounded-lg px-3 py-1.5 text-gray-700 dark:text-gray-300 focus:ring-1 focus:ring-primary-500 focus:outline-none">
            <option>2024</option>
            <option>2023</option>
          </select>
        </div>
        <RevenueAreaChart data={revenueData} />
      </Card>
      <Card className="p-6">
        <h3 className="font-display font-bold text-gray-900 dark:text-white mb-1">
          Traffic Sources
        </h3>
        <p className="text-sm text-gray-400 mb-6">Where your users come from</p>
        <DonutChart data={trafficData} />
      </Card>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <Card className="lg:col-span-2 p-6">
        <div className="mb-6">
          <h3 className="font-display font-bold text-gray-900 dark:text-white">
            User Growth
          </h3>
          <p className="text-sm text-gray-400 mt-0.5">
            New active users per month
          </p>
        </div>
        <UsersBarChart data={revenueData} />
      </Card>
      <Card className="p-6">
        <h3 className="font-display font-bold text-gray-900 dark:text-white mb-6">
          Quick Stats
        </h3>
        <div className="space-y-5">
          {[
            { label: "Avg. Session Duration", value: "6m 42s", bar: 0.68 },
            { label: "Bounce Rate", value: "24.3%", bar: 0.24 },
            { label: "Conversion Rate", value: "8.7%", bar: 0.87 },
            { label: "Net Promoter Score", value: "74", bar: 0.74 },
          ].map((item, i) => (
            <div key={i}>
              <div className="flex justify-between text-sm mb-1.5">
                <span className="text-gray-600 dark:text-gray-400">
                  {item.label}
                </span>
                <span className="font-semibold text-gray-900 dark:text-white">
                  {item.value}
                </span>
              </div>
              <div className="h-1.5 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-primary-500 to-accent-500 rounded-full"
                  style={{ width: `${item.bar * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  </div>
);

export default Analytics;
